export var userActions = {
    deleteUser: {
        id: 0,
        enabled: true,
        description: 'Remove',
        disabledMessage: 'Remove unavailable',
        icon: 'ag-trash',
        callback: function () { },
    },
};
